














































































































































































































































































































































































































































































































import { InputInterface, TypeInput, getTypeInputSpec } from '../types/Exa_Input'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InputCheckBox from './InputCheckBox.vue'
import InputText from './InputText.vue'
import InputSelect from './InputSelect.vue'
import ContentPartieAuto from './ContentPartieAuto.vue'
import InputFormulaire from './InputFormulaire.vue'
import InputFile from './InputFile.vue'
import InputEmail from './InputEmail.vue'
import InputDateTime from './InputDateTime.vue'
import InputDate from './InputDate.vue'
import InputNumber from './InputNumber.vue'
import InputPhone from './InputPhone.vue'
import InputRadio from './InputRadio.vue'
import InputTextArea from './InputTextArea.vue'
import InputChoixMultiple from './InputChoixMultiple.vue'
import ZoneTextInfo from './ZoneTextInfo.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { PartieFormulaireInterface, TypePartie } from '../types/Exa_PartieFormulaire'
import { mapGetters } from 'vuex'
import { isNull } from 'lodash'
import { BButton, BModal } from 'bootstrap-vue'

@Component({
    computed: {
        ...mapGetters('exa_formulaire', ['InputIsConditionForAnotherInput']),
        ...mapGetters('exa_partieFormulaire', ['libelle', 'inputSelect', 'getInputById'])
    },
    components: {

        InputCheckBox: InputCheckBox,
        InputText: InputText,
        InputSelect: InputSelect,
        InputFormulaire: InputFormulaire,
        FontAwesomeIcon: FontAwesomeIcon,
        ContentPartieAuto: ContentPartieAuto,
        InputFile: InputFile,
        InputEmail: InputEmail,
        InputDateTime: InputDateTime,
        InputDate: InputDate,
        InputNumber: InputNumber,
        InputPhone: InputPhone,
        InputRadio: InputRadio,
        InputTextArea: InputTextArea,
        InputChoixMultiple: InputChoixMultiple,
        ZoneTextInfo: ZoneTextInfo,
        'b-button': BButton,
        'b-modal': BModal
    }
})
export default class PartieFormulaire extends Vue {
    @Prop() mode_edit!: boolean
    @Prop() partie!: PartieFormulaireInterface
    @Prop() canMove!: boolean
    @Prop() mode_lecture!: boolean
    @Prop({ default: false }) check_validation!: boolean
    @Prop() user!: any
    @Prop({ default: false }) visionneuse_enabled!: boolean

    @Prop() storeDocument!: Function | null
    @Prop() getDocument!: Function | null
    @Prop() deleteDocument!: Function | null
    @Prop() storeDocumentReference!: Function | null
    @Prop() getDocumentReference!: Function | null
    @Prop() deleteDocumentReference!: Function | null

    randomForKey = 0

    TypePartie = TypePartie

    partieTemp: PartieFormulaireInterface | null = null

    typeInput = TypeInput

    showModalEditionInput = false
    showModalMessageDeleteInput = false

    otherInputs: Array<any> = []
    otherInputsFull: Array<any> = []

    condition_champ_input_type_reponse = 1
    data_condition_type_reponse = { options :[{ value:  1, libelle:'renseigné', ordre: 1 }, { value: 2, libelle: 'renseigné et a pour valeur', ordre: 2 }] }  

    input_file_data =  { min: 0, max: 5 } 

    data_precision = {
        options: [
            {
                value: 10,
                libelle: '10',
                ordre: 1
            },
            {
                value: 1,
                libelle: '1',
                ordre: 2
            },
            {
                value: 0.1,
                libelle: '0.1',
                ordre: 3
            },
            {
                value: 0.01,
                libelle: '0.01',
                ordre: 4
            },
            {
                value: 0.001,
                libelle: '0.001',
                ordre: 5
            },
            {
                value: 0.0001,
                libelle: '0.0001',
                ordre: 6
            }
        ]
    }

    formatageSelectData = {
        options: [
            {
                value: null,
                libelle: 'Aucun',
                ordre: 1
            },
            {
                value: 'toUpper',
                libelle: 'Tout en majuscule',
                ordre: 2
            },
            {
                value: 'toLower',
                libelle: 'Tout en minuscule',
                ordre: 3
            },
            {
                value: 'firstToUpper',
                libelle: 'Premiere lettre de chaque mot en majuscule',
                ordre: 4
            }
        ]
    }

    typeSelectData = {
        options: [
            {
                value: TypeInput.TYPE_CHECK_BOX,
                libelle: getTypeInputSpec(TypeInput.TYPE_CHECK_BOX).libelle,
                ordre: 1
            },
            {
                value: TypeInput.TYPE_TEXT,
                libelle: getTypeInputSpec(TypeInput.TYPE_TEXT).libelle,
                ordre: 2
            },
            {
                value: TypeInput.TYPE_SELECT,
                libelle: getTypeInputSpec(TypeInput.TYPE_SELECT).libelle,
                ordre: 3
            },
            {
                value: TypeInput.TYPE_DATE,
                libelle: getTypeInputSpec(TypeInput.TYPE_DATE).libelle,
                ordre: 4
            },
            {
                value: TypeInput.TYPE_DATE_TIME,
                libelle: getTypeInputSpec(TypeInput.TYPE_DATE_TIME).libelle,
                ordre: 5
            },
            {
                value: TypeInput.TYPE_NUMBER,
                libelle: getTypeInputSpec(TypeInput.TYPE_NUMBER).libelle,
                ordre: 6
            },
            {
                value: TypeInput.TYPE_PHONE_NUMBER,
                libelle: getTypeInputSpec(TypeInput.TYPE_PHONE_NUMBER).libelle,
                ordre: 7
            },
            {
                value: TypeInput.TYPE_FILE,
                libelle: getTypeInputSpec(TypeInput.TYPE_FILE).libelle,
                ordre: 8
            },
            {
                value: TypeInput.TYPE_RADIO,
                libelle: getTypeInputSpec(TypeInput.TYPE_RADIO).libelle,
                ordre: 9
            },
            {
                value: TypeInput.TYPE_TEXT_AREA,
                libelle: getTypeInputSpec(TypeInput.TYPE_TEXT_AREA).libelle,
                ordre: 10
            },
            {
                value: TypeInput.TYPE_TEXT_INFO,
                libelle: getTypeInputSpec(TypeInput.TYPE_TEXT_INFO).libelle,
                ordre: 11
            },
            {
                value: TypeInput.TYPE_CHOIX_MULTIPLE,
                libelle: getTypeInputSpec(TypeInput.TYPE_CHOIX_MULTIPLE).libelle,
                ordre: 12
            },
            {
                value: TypeInput.TYPE_EMAIL,
                libelle: getTypeInputSpec(TypeInput.TYPE_EMAIL).libelle,
                ordre: 13
            }
        ]
    }

    data_position_placement = { 
        options: [{
            value: 'before',
            libelle: 'Avant',
            ordre: 1
        },
        {
            value: 'after',
            libelle: 'Après',
            ordre: 2
        }]
    }
    
    data_position_inputs: any = null
    data_condition_inputs: any = null
    select_position_placement_default_value: any = null
    select_position_inputs_default_value = -1

    conditionInput: any | null  = null

    conditionOk = false
    condition: any | null = null

    refreshKey = 1

    showModalMessageDocumentTropLourd = false

    // condition: InputInterface | null = null

    data_options_temp = ''

    documentFileTemp: any = null

    key_options_temp = 'keyoptionstemp_'

    showModalMessageDocumentErreur = false
    errorDoc: any = null

    values_condition_input_partie_auto: Array<any> = []


    /** 
     * genereOptions 
     * Cette fonction génère les options à partir des données temporaires. 
     * @param {string} data_options_temp - Les données temporaires sous forme de chaîne de caractères. 
     */ 
    genereOptions () {
        const data_temp = this.data_options_temp.split('\n')
        const optionsTemp = []
        for (let i =  0; i < data_temp.length; i++) {
            if (data_temp[i].includes(';')) {
                const data_temp_bis = data_temp[i].split(';')
                optionsTemp.push({
                    value: data_temp_bis[0],
                    libelle: data_temp_bis[1],
                    ordre: i + 1
                })
            } else {
                optionsTemp.push({
                    value: i + 1,
                    libelle: data_temp[i],
                    ordre: i + 1
                })
            }
        }
        if (optionsTemp.length > 0) {
            this.$store.state.exa_partieFormulaire.inputSelect.data.options = optionsTemp
        }
        this.key_options_temp = this.key_options_temp.split('_')[0] + Math.random()
    }

    /** 
     * refValidityHandler 
     * Vérifie la validité de la référence. 
     * @returns {string} - Message d'erreur si la référence n'est pas unique, sinon une chaîne vide. 
     */  
    refValidityHandler () {
        if (!this.$store.getters['exa_formulaire/isRefIsUnique'](this.$store.state.exa_partieFormulaire.inputSelect.ref, this.$store.state.exa_partieFormulaire.inputSelect.id)) {
            return 'La référence doit être unique'
        } else {
            return ''
        }
    }
    
    /** 
     * emitUpdateStructureFormulaire 
     * Met à jour la structure du formulaire en déclenchant les actions appropriées. 
     * @param  - Aucun paramètre requis. 
     */  
    emitUpdateStructureFormulaire() {
        this.$store.dispatch('exa_formulaire/updateJson')
        this.$emit('updateFormulaire')
    }

    /** 
     * emitUpdateValuesFormulaire 
     * Met à jour les valeurs du formulaire en déclenchant les actions appropriées. 
     * @param - Aucun paramètre requis. 
     */ 
    emitUpdateValuesFormulaire() {
        this.$store.dispatch('exa_formulaire/updateJsonValues')
        this.$emit('updateValuesFormulaire')
    }

    /** 
     * loadPartie 
     * Charge la partie du formulaire en utilisant la directive @Watch pour détecter les changements de la propriété 'partie'. 
     * @param {None} - Aucun paramètre requis. 
     */ 
    @Watch('partie')
    loadPartie () {
        this.partieTemp = this.$store.state.exa_formulaire.parties.find((p: PartieFormulaireInterface) => Number(p.id) === Number(this.partie.id))
    }

    /** 
     * partieAutoHandler 
     * Gère les modifications de la partie automatique du formulaire. 
     * @param {any} e - Événement contenant les informations de la partie automatique modifiée. 
     */ 
    partieAutoHandler(e: any) {
        if (this.partie.value === null || this.partie.value === undefined) {
            this.partie.value = []
        }
        const valueTemp = []
        let found  = false
        for (let i  = 0; i < this.partie.value.length; i++) {
            if (this.partie.value[i].cle === e.value.split('_')[0]) {
                if (!this.partie.value[i].value.includes(e.value.split('_')[1]) && this.partie.value[i].value.length < Number(e.max)) {
                    this.partie.value[i].value.push(e.value.split('_')[1])
                } else {
                    const valuesTemp = []
                    for (let j = 0; j < this.partie.value[i].value.length; j++) {
                        if (this.partie.value[i].value[j] !== e.value.split('_')[1]) {
                            valuesTemp.push(this.partie.value[i].value[j])
                        }
                    }
                    this.partie.value[i].value = valuesTemp
                }
                found = true
            } // else if (this.partie.value[i].cle !== e.value.split('_')[0])  {
            valueTemp.push(this.partie.value[i])
            // }
        }
        this.partie.value = valueTemp
        if (!found) {
            this.partie.value.push({ cle:  e.value.split('_')[0], value: [e.value.split('_')[1]], min: e.min, max: e.max })
        }
        this.getNbreReponseNecessairePartieAuto()
        this.emitUpdateValuesFormulaire()
        this.refreshKey = Math.random()
        this.$emit('conditionCheck', e)
    }

    /** 
     * getNbreReponseNecessairePartieAuto 
     * Calcule le nombre total de réponses nécessaires pour la partie automatique du formulaire. 
     * @returns {Array} - Un tableau contenant le nombre de réponses actuellement sélectionnées et le nombre total de réponses nécessaires. 
     */
    getNbreReponseNecessairePartieAuto () {
        let total = 0
        total += this.getNbreReponseNecessairePartieAutoBis(this.partie.data.data.content)
        /*
        for (let i = 0; i < this.partie.data.data.content.length; i++) {
            if (this.partie.data.data.content[i].content && this.partie.data.data.content[i].content.length > 0) {
                total += this.getNbreReponseNecessairePartieAutoBis(this.partie.data.data.content[i].content)
            }
        }
        */
        let nbReps = 0
        if (this.partie.value) {
            for (let j = 0; j < this.partie.value.length; j++) {
                if (this.partie.value[j].value.length > 0 && this.partie.value[j].value.length >= this.partie.value[j].min && this.partie.value[j].value.length <= this.partie.value[j].max) {
                    nbReps++
                }
            }
        }
        this.partie.anomalie = ''
        if (nbReps < total) {
            this.partie.anomalie = nbReps + ' / ' + total + ' ' + (nbReps > 1 ? 'choix faits' : 'choix fait')
        }
        return [nbReps, total]
    }

    /** 
     * getNbreReponseNecessairePartieAutoBis 
     * Calcule le nombre total de réponses nécessaires pour les données spécifiées. 
     * @param {any} data - Les données pour lesquelles le nombre de réponses nécessaires doit être calculé. 
     * @returns {number} - Le nombre total de réponses nécessaires. 
     */
    getNbreReponseNecessairePartieAutoBis (data: any) {
        let total = 0
        for (let i = 0; i < data.length; i++) {
            if (data[i].value !== null && data[i].value !== undefined) {
                return 1
            } else {
                if (data[i].content) {
                    total += this.getNbreReponseNecessairePartieAutoBis(data[i].content)
                }            
            }
        }
        return total
    }
    
    /** 
     * saisieInputHandler 
     * Gère la saisie de l'entrée de données en déclenchant les actions appropriées. 
     * @param {any} retour - Les données de saisie fournies. 
     */
    saisieInputHandler(retour: any) {
        this.$store.dispatch('exa_partieFormulaire/setInputValue', retour)
        // this.$store.dispatch('exa_formulaire/updateJsonValues')
        this.emitUpdateValuesFormulaire()
        this.$emit('conditionCheck', retour)
    }

    /** 
     * showVisionneuse 
     * Cette fonction émet un événement 'showVisionneuse' avec le paramètre 'e'. 
     *  
     * @param {any} e - Le paramètre de la fonction. 
     */
    showVisionneuse (e: any) {
        this.$emit('showVisionneuse', e)
    }

    /** 
     * conditionValueInputHandler 
     * Gère la saisie de la valeur de condition en déclenchant la fonction changeHandler avec les données appropriées. 
     * @param {any} retour - Les données de saisie de la valeur de condition. 
     */  
    conditionValueInputHandler(retour: any) {
        this.changeHandler({ ident: 'input_condition_value_input', value: retour.value })
    }

    getValuesPartieAuto (conditionInput: any) {
        let retour: Array<any> = []
        for (let i = 0; i < conditionInput.data.data.content.length; i++) {
            retour = retour.concat(this.getContentValue(conditionInput.data.data.content[i]))
        }
        return retour
    }

    getContentValue(content: any) {
        let retour: Array<any> = []
        if (content.value) {
            return [content.value]
        } else if (content.content) {
            for (let i = 0; i < content.content.length; i++) {
                retour = retour.concat(this.getContentValue(content.content[i]))
            }
        }
        return retour
    }

    /** 
     * changeHandler 
     * Gère les modifications des valeurs de retour en mettant à jour les propriétés appropriées. 
     * @param {any} retour - Les données de retour fournies. 
     */
    timeOutTemp = 0
    changeHandler(retour: any) {
        switch (retour.ident) {
            case 'format_input':
                if (this.$store.state.exa_partieFormulaire.inputSelect.data === undefined || this.$store.state.exa_partieFormulaire.inputSelect.data === null) {
                    this.$store.state.exa_partieFormulaire.inputSelect.data = {}
                }
                if (this.$store.state.exa_partieFormulaire.inputSelect.data.format === undefined) {
                    if (this.$store.state.exa_partieFormulaire.inputSelect.data.min === undefined && this.$store.state.exa_partieFormulaire.inputSelect.data.max === undefined) {
                        this.$store.state.exa_partieFormulaire.inputSelect.data = { min: 0, max: 0, format: null }
                    }
                    if (this.$store.state.exa_partieFormulaire.inputSelect.data.min === undefined) {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.min = 0
                    }
                    if (this.$store.state.exa_partieFormulaire.inputSelect.data.max === undefined) {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.max = 0
                    }
                    this.$store.state.exa_partieFormulaire.inputSelect.data.format = null
                }
                this.$store.state.exa_partieFormulaire.inputSelect.data.format = retour.value
                break
            case 'select_condition_champ_input_type_reponse':
                this.condition_champ_input_type_reponse = retour.value
                if (this.conditionInput !== null && this.conditionInput.inputs && this.conditionInput.inputs.length === 0) {
                    this.values_condition_input_partie_auto = []
                    const values = new Set(this.getValuesPartieAuto(this.conditionInput))
                    
                    for (const value of values) {
                        this.values_condition_input_partie_auto.push({
                            value: value,
                            libelle: value
                        })
                    }
                }
                if (Number(retour.value) === 1) {
                    this.$store.state.exa_partieFormulaire.inputSelect.condition.value = null
                }
                break
            case 'libelle_input': 
                this.$store.state.exa_partieFormulaire.inputSelect.libelle = retour.value
                break
            case 'ref_input': 
                this.$store.state.exa_partieFormulaire.inputSelect.ref = retour.value
                break
            case 'prompt_input': 
                this.$store.state.exa_partieFormulaire.inputSelect.data.prompt = retour.value
                break
            case 'requis_input': 
                this.$store.state.exa_partieFormulaire.inputSelect.requis = retour.value
                break
            case 'type_input': 
                this.$store.state.exa_partieFormulaire.inputSelect.type = parseInt(retour.value)
                this.$store.state.exa_partieFormulaire.inputSelect.data = {}
                if (this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_FILE || 
                    this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_TEXT) {
                    this.$store.state.exa_partieFormulaire.inputSelect.data.max = this.$store.state.exa_partieFormulaire.inputSelect.data && this.$store.state.exa_partieFormulaire.inputSelect.data.max ? this.$store.state.exa_partieFormulaire.inputSelect.data.max : 1
                    this.$store.state.exa_partieFormulaire.inputSelect.data.min = this.$store.state.exa_partieFormulaire.inputSelect.data && this.$store.state.exa_partieFormulaire.inputSelect.data.min ? this.$store.state.exa_partieFormulaire.inputSelect.data.min : 1
                }
                if (this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_NUMBER) {
                    this.$store.state.exa_partieFormulaire.inputSelect.data.max = this.$store.state.exa_partieFormulaire.inputSelect.data && this.$store.state.exa_partieFormulaire.inputSelect.data.max ? this.$store.state.exa_partieFormulaire.inputSelect.data.max : 1
                    this.$store.state.exa_partieFormulaire.inputSelect.data.min = this.$store.state.exa_partieFormulaire.inputSelect.data && this.$store.state.exa_partieFormulaire.inputSelect.data.min ? this.$store.state.exa_partieFormulaire.inputSelect.data.min : 1
                    this.$store.state.exa_partieFormulaire.inputSelect.data.step = this.$store.state.exa_partieFormulaire.inputSelect.data && this.$store.state.exa_partieFormulaire.inputSelect.data.step ? this.$store.state.exa_partieFormulaire.inputSelect.data.step : 1
                }
                if (this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_SELECT || 
                this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_CHOIX_MULTIPLE || 
                    this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_RADIO) {
                    if (!this.$store.state.exa_partieFormulaire.inputSelect.data) {
                        this.$store.state.exa_partieFormulaire.inputSelect.data = {
                            prompt: '',
                            options: []
                        }
                    } else {
                        if (!this.$store.state.exa_partieFormulaire.inputSelect.data.prompt) {
                            this.$store.state.exa_partieFormulaire.inputSelect.data.prompt = ''
                        }
                        if (!this.$store.state.exa_partieFormulaire.inputSelect.data.options) {
                            this.$store.state.exa_partieFormulaire.inputSelect.data.options = []
                        }
                    } 
                }
                break
            case 'select_position_placement':
                this.select_position_placement_default_value = retour.value
                break
            case 'select_position_input':
                this.select_position_inputs_default_value = retour.value               
                break
            case 'condition_input':
                this.$store.state.exa_partieFormulaire.inputSelect.condition = null
                if (retour.value) {
                    this.$store.state.exa_partieFormulaire.inputSelect.condition = {
                        champ_id: null,
                        value: null
                    }
                    if (this.data_position_inputs.options.length === 1) {
                        this.$store.state.exa_partieFormulaire.inputSelect.condition.champ_id = this.data_position_inputs.options[0].value
                        this.conditionInput = this.$store.getters['exa_formulaire/getInputById'](this.data_position_inputs.options[0].value)
                    }
                } else {
                    this.conditionInput = null
                    this.$store.state.exa_partieFormulaire.inputSelect.condition = null
                }
                break
            case 'select_condition_champ_input':
                this.$store.state.exa_partieFormulaire.inputSelect.condition.champ_id = retour.value
                this.conditionInput = this.$store.getters['exa_formulaire/getInputById'](retour.value)
                this.condition_champ_input_type_reponse = 1
                break
            case 'input_condition_value_input':
                this.$store.state.exa_partieFormulaire.inputSelect.condition.value = retour.value
                break
            case 'data_step': 
                this.$store.state.exa_partieFormulaire.inputSelect.data.step = retour.value
                break
            case 'data_file': 
                this.$store.state.exa_partieFormulaire.inputSelect.data.files = retour.value
                break
            default:
                if (retour instanceof Event) {
                    const eventRetour: any = retour
                    
                    if (this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_DATE_TIME || this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_DATE)  {
                        // console.log(eventRetour.target.value)
                        if (eventRetour.target.id === 'data_min') {
                            if (this.$store.state.exa_partieFormulaire.inputSelect.data === null || this.$store.state.exa_partieFormulaire.inputSelect.data.min === null) {
                                this.$store.state.exa_partieFormulaire.inputSelect.data = { min: eventRetour.target.value, max: eventRetour.target.value }
                            }
                            this.$store.state.exa_partieFormulaire.inputSelect.data.min = eventRetour.target.value
                            // console.log(this.$store.state.exa_partieFormulaire.inputSelect.data)
                        }
                        if (eventRetour.target.id === 'data_max') {
                            if (this.$store.state.exa_partieFormulaire.inputSelect.data === null || this.$store.state.exa_partieFormulaire.inputSelect.data.max === null) {
                                this.$store.state.exa_partieFormulaire.inputSelect.data = { min: eventRetour.target.value, max: eventRetour.target.value }
                            }
                            this.$store.state.exa_partieFormulaire.inputSelect.data.max = eventRetour.target.value
                            // console.log(this.$store.state.exa_partieFormulaire.inputSelect.data)
                        }
                    } else {
                        if (eventRetour.target.id === 'data_min') {
                            if (this.$store.state.exa_partieFormulaire.inputSelect.data.length === 0) {
                                this.$store.state.exa_partieFormulaire.inputSelect.data = { min: Number(eventRetour.target.value), max: Number(eventRetour.target.value) }
                            }
                            this.$store.state.exa_partieFormulaire.inputSelect.data.min = Number(eventRetour.target.value)
                        }
                        if (eventRetour.target.id === 'data_max') {
                            if (this.$store.state.exa_partieFormulaire.inputSelect.data.length === 0) {
                                this.$store.state.exa_partieFormulaire.inputSelect.data = { min: 1, max: Number(eventRetour.target.value) }
                            }
                            this.$store.state.exa_partieFormulaire.inputSelect.data.max = Number(eventRetour.target.value)
                        }
                    }
                    if (eventRetour.target.id === 'is_description') {
                        this.$store.state.exa_partieFormulaire.inputSelect.description = eventRetour.target.value
                    }
                } else if (retour.ident.includes('option_libelle_')) {
                    this.$store.state.exa_partieFormulaire.inputSelect.data.options[retour.ident.split('_')[2]].libelle = retour.value
                }
                break
        }
        // this.$store.dispatch('exa_formulaire/updateJson')       
        // this.emitUpdateStructureFormulaire() 
        clearTimeout(this.timeOutTemp)
        this.timeOutTemp = setTimeout(() => {
            this.randomForKey = Math.random()
        }, 500)
    }

    /** 
     * closeModalDocTropLourd 
     * Ferme la modal affichant le message de document trop lourd. 
     * @param {None} - Aucun paramètre requis. 
     */
    closeModalDocTropLourd() {
        this.showModalMessageDocumentTropLourd = false
    }

    /** 
     * selectFile 
     * Gère la sélection d'un fichier en vérifiant sa taille et en effectuant les actions appropriées. 
     * @param {Event} e - L'événement de sélection de fichier. 
     */
    selectFile (e: Event) {
        if (e.target !== null) {
            const target = e.target as HTMLInputElement
            const file: File = (target.files as FileList)[0]

            const maxAllowedSize = 5 * 1024 * 1024
            if (file.size > maxAllowedSize) {
                (e.target as HTMLInputElement).files = null
                const inputfile: any = this.$refs.data_file
                inputfile.value = null
                this.showModalMessageDocumentTropLourd = true
            } else {
                if (this.storeDocument) {
                    this.storeDocument(file.name, file).then((response: any) => {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.file = { titre: file.name, id: response.id }
                    }).catch((error: any) => {
                        this.errorDoc = error
                        this.showModalMessageDocumentErreur = true
                        console.log('error : ' + error)
                    })
                } else {
                    const reader = new FileReader()
    
                    reader.addEventListener('load', () => {
                        this.documentFileTemp = reader.result
                        this.$store.state.exa_partieFormulaire.inputSelect.data.file = { titre: file.name, data: this.documentFileTemp }
                    }, false)
    
                    reader.readAsDataURL(file)
                }
            }
        }
    }

    // input type select
    /** 
     * addOption 
     * Ajoute une nouvelle option à la liste des options de l'inputSelect. 
     * @param {None} - Aucun paramètre requis. 
     */
    addOption() {
        const optionTemp = { 
            value: 1,  // valeur de l'option 
            libelle: '', // label de l'option
            ordre: 1 // numéro d'ordre de l'option
        }
        
        const optionsTemp: Array<any> = []
        let  dataTemp = {
            prompt: '',
            options: optionsTemp
        }
        if (this.$store.state.exa_partieFormulaire.inputSelect && 
        this.$store.state.exa_partieFormulaire.inputSelect.data) {
            dataTemp = this.$store.state.exa_partieFormulaire.inputSelect.data
        }
        if (dataTemp.options && dataTemp.options.length > 0) {
            for (let i = 0; i < dataTemp.options.length; i++) {
                if (Number(optionTemp.ordre) >= Number(dataTemp.options[i].ordre)) {
                    optionTemp.ordre = Number(dataTemp.options[i].ordre) + 1
                }
                if (Number(optionTemp.value) >= Number(dataTemp.options[i].value)) {
                    optionTemp.value = Number(dataTemp.options[i].value) + 1
                }
            }
        }
        dataTemp.options.push(optionTemp)
        this.$store.state.exa_partieFormulaire.inputSelect.data = dataTemp
        this.$store.state.exa_partieFormulaire.inputSelect.requis = !this.$store.state.exa_partieFormulaire.inputSelect.requis
        this.$store.state.exa_partieFormulaire.inputSelect.requis = !this.$store.state.exa_partieFormulaire.inputSelect.requis    
    }

    /** 
     * moveOption 
     * Déplace une option vers le haut ou vers le bas dans la liste des options de l'inputSelect. 
     * @param {number} keyOption - La clé de l'option à déplacer. 
     * @param {string} direction - La direction dans laquelle déplacer l'option ('up' pour vers le haut, 'down' pour vers le bas). 
     */
    moveOption(keyOption: number, direction: string) {
        const optionsTemp = []
        let optionTemp = null
        if (direction === 'down') {
            for (let i = 0; i < this.$store.state.exa_partieFormulaire.inputSelect.data.options.length; i++) {
                if (i === keyOption) {
                    optionTemp = JSON.parse(JSON.stringify(this.$store.state.exa_partieFormulaire.inputSelect.data.options[i]))
                } else {
                    if (optionTemp) {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].value = i
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].ordre = i
                        optionsTemp.push(this.$store.state.exa_partieFormulaire.inputSelect.data.options[i])
                        optionTemp.value = i + 1
                        optionTemp.ordre = i + 1
                        optionsTemp.push(optionTemp)
                        optionTemp = null
                    } else {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].value = i + 1
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].ordre = i + 1
                        optionsTemp.push(this.$store.state.exa_partieFormulaire.inputSelect.data.options[i])
                    }
                }
            }
        } else if (direction === 'up') {
            for (let i = this.$store.state.exa_partieFormulaire.inputSelect.data.options.length - 1; i >= 0; i--) {
                if (i === keyOption) {
                    optionTemp = JSON.parse(JSON.stringify(this.$store.state.exa_partieFormulaire.inputSelect.data.options[i]))
                } else {
                    if (optionTemp) {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].value = i + 2
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].ordre = i + 2
                        optionsTemp.unshift(this.$store.state.exa_partieFormulaire.inputSelect.data.options[i])
                        optionTemp.value = i + 1
                        optionTemp.ordre = i + 1
                        optionsTemp.unshift(optionTemp)
                        optionTemp = null
                    } else {
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].value = i + 1
                        this.$store.state.exa_partieFormulaire.inputSelect.data.options[i].ordre = i + 1
                        optionsTemp.unshift(this.$store.state.exa_partieFormulaire.inputSelect.data.options[i])
                    }
                }
            }
        }
        this.$store.state.exa_partieFormulaire.inputSelect.data.options = optionsTemp
        this.$store.state.exa_partieFormulaire.inputSelect.requis = !this.$store.state.exa_partieFormulaire.inputSelect.requis
        this.$store.state.exa_partieFormulaire.inputSelect.requis = !this.$store.state.exa_partieFormulaire.inputSelect.requis    
    }

    /** 
     * deleteOption 
     * Supprime une option de la liste des options de l'inputSelect. 
     * @param {number} keyOption - La clé de l'option à supprimer. 
     */
    deleteOption(keyOption: number) {
        this.$store.state.exa_partieFormulaire.inputSelect.data.options.splice(keyOption, 1)
        this.$store.state.exa_partieFormulaire.inputSelect.requis = !this.$store.state.exa_partieFormulaire.inputSelect.requis
        this.$store.state.exa_partieFormulaire.inputSelect.requis = !this.$store.state.exa_partieFormulaire.inputSelect.requis
    }

    // --------

    /** 
     * editPartie 
     * Émet un événement pour éditer la partie avec les données de la partie temporaire. 
     * @param {None} - Aucun paramètre requis. 
     */
    editPartie() {
        this.$emit('edit_partie', this.partieTemp)
    }

    /** 
     * movePartie 
     * Émet un événement pour déplacer la partie avec les données de la partie temporaire. 
     * @param {None} - Aucun paramètre requis. 
     */
    movePartie() {
        this.$emit('move_partie', this.partieTemp)
    }

    /** 
     * deletePartie 
     * Émet un événement pour supprimer la partie avec les données de la partie temporaire. 
     * @param {None} - Aucun paramètre requis. 
     */
    deletePartie() {
        this.$emit('delete_partie', this.partieTemp)
    }

    /** 
     * buildDataPositionInput 
     * Construit les données de positionnement des inputs en créant une liste d'options. 
     * @param {None} - Aucun paramètre requis. 
     */
    buildDataPositionInput () {
        const optionsTemp: Array<any> = []
        for (let i = 0; i < this.otherInputs.length; i++) {
            optionsTemp.push({
                value: this.otherInputs[i].id,
                libelle: this.otherInputs[i].libelle,
                ordre: i + 1
            })
            if ((Number(this.$store.state.exa_partieFormulaire.inputSelect.ordre) === 0  && 
            ((Number(this.$store.state.exa_partieFormulaire.inputSelect.id) === 0 && 
            Number(this.otherInputs[i].ordre) === 0) || Number(this.otherInputs[i].ordre) === 1)) || 
            (Number(this.$store.state.exa_partieFormulaire.inputSelect.ordre) === (Number(this.otherInputs[i].ordre)  + 1))) {
                this.select_position_inputs_default_value =  this.otherInputs[i].id
            }
        }
        this.data_position_inputs = null
        this.data_position_inputs = {
            options: optionsTemp  
        }      
    }

    /** 
     * buildDataConditionInput 
     * Construit les données de conditionnement des inputs en créant une liste d'options. 
     * @param {None} - Aucun paramètre requis. 
     */
    buildDataConditionInput () {
        const optionsTemp: Array<any> = []
        for (let i = 0; i < this.otherInputsFull.length; i++) {
            optionsTemp.push({
                value: (this.otherInputsFull[i].inputs && this.otherInputsFull[i].inputs.length  === 0) ? 'p_' + this.otherInputsFull[i].id :  this.otherInputsFull[i].id,
                libelle: this.otherInputsFull[i].libelle,
                ordre: i + 1
            })
            if ((Number(this.$store.state.exa_partieFormulaire.inputSelect.ordre) === 0  && 
            ((Number(this.$store.state.exa_partieFormulaire.inputSelect.id) === 0 && 
            Number(this.otherInputsFull[i].ordre) === 0) || Number(this.otherInputsFull[i].ordre) === 1)) || 
            (Number(this.$store.state.exa_partieFormulaire.inputSelect.ordre) === (Number(this.otherInputsFull[i].ordre) + 1))) {
                this.select_position_inputs_default_value = this.otherInputsFull[i].id
            }
        }
        this.data_condition_inputs = null
        this.data_condition_inputs = {
            options: optionsTemp  
        }      
    }
    
    /** 
     * ajouterInput 
     * Ajoute un nouvel input à la partie en cours et effectue les actions nécessaires pour mettre à jour les données. 
     * @param {None} - Aucun paramètre requis. 
     */
    ajouterInput() {
        this.conditionInput  = null
        this.$store.dispatch('exa_partieFormulaire/loadPartieFormulaire', this.partieTemp)
        this.$store.dispatch('exa_partieFormulaire/addInput')
        this.otherInputs = this.$store.state.exa_partieFormulaire.inputs
        this.otherInputsFull = this.$store.getters['exa_formulaire/inputs']()
        
        this.buildDataPositionInput()
        this.buildDataConditionInput()
        this.select_position_placement_default_value = 'after'
        this.condition_champ_input_type_reponse = 1
        this.showModalEditionInput = true
    }

    /** 
     * editInput 
     * Édite l'input spécifié en effectuant les actions nécessaires pour mettre à jour les données. 
     * @param {InputInterface} input - L'input à éditer. 
     */
    editInput(input: InputInterface) {
        this.$store.dispatch('exa_partieFormulaire/loadPartieFormulaire', this.partieTemp)
        this.$store.dispatch('exa_partieFormulaire/setInputSelect', input)
        if (this.$store.state.exa_partieFormulaire.inputSelect.type === TypeInput.TYPE_SELECT) {
            if (!this.$store.state.exa_partieFormulaire.inputSelect.data) {
                this.$store.state.exa_partieFormulaire.inputSelect.data = {
                    prompt: '',
                    options: []
                }
            } else {
                if (!this.$store.state.exa_partieFormulaire.inputSelect.data.prompt) {
                    this.$store.state.exa_partieFormulaire.inputSelect.data.prompt = ''
                }
                if (!this.$store.state.exa_partieFormulaire.inputSelect.data.options) {
                    this.$store.state.exa_partieFormulaire.inputSelect.data.options = []
                }
            } 
        }
        this.otherInputs  = this.$store.state.exa_partieFormulaire.inputs.filter((inputTemp: any) => Number(inputTemp.id) !== Number(input.id) || inputTemp.inputs)
        const otherInputsFullTemp = this.$store.getters['exa_formulaire/inputs']()
        this.otherInputsFull = otherInputsFullTemp.filter((inputTemp: any) =>  Number(inputTemp.id) !== Number(input.id) || inputTemp.inputs)
        this.buildDataPositionInput()
        this.buildDataConditionInput()

        this.condition_champ_input_type_reponse = 1
        if (input.condition) {
            this.conditionInput = this.$store.getters['exa_formulaire/getInputById'](input.condition.champ_id)
        }
        if (this.$store.state.exa_partieFormulaire.inputSelect.condition && !isNull(this.$store.state.exa_partieFormulaire.inputSelect.condition.value)) {
            this.condition_champ_input_type_reponse = 2
        }
        this.select_position_placement_default_value = this.$store.state.exa_partieFormulaire.inputSelect.ordre === 0 ? 'before' : 'after'
        this.showModalEditionInput = true
    }

    /** 
     * editInputSuite 
     * Effectue les actions nécessaires après l'édition de l'input, telles que la sauvegarde de l'input sélectionné, la mise à jour de l'ordre des inputs, la fermeture de la modal d'édition, etc. 
     * @param {None} - Aucun paramètre requis. 
     */
    editInputSuite() {
        this.$store.dispatch('exa_partieFormulaire/saveInputSelect', this.$store.getters['exa_formulaire/getNextInputId'])
        this.$store.dispatch('exa_partieFormulaire/setOrderInputs', { way: this.select_position_placement_default_value, markedInputId: this.select_position_inputs_default_value })
        this.$store.dispatch('exa_partieFormulaire/setInputSelect', null)
        this.showModalEditionInput = false
        if (this.partieTemp) {
            this.partieTemp.inputs.sort((a: InputInterface, b: InputInterface) => Number(a.ordre) > Number(b.ordre) ? 1 : (Number(a.ordre) < Number(b.ordre) ? -1 : 0))
        }
        // this.$store.dispatch('exa_formulaire/updateJson')
        this.emitUpdateStructureFormulaire()
        this.loadPartie()
    }

    /** 
     * cancelEdit 
     * Annule l'édition de l'input en fermant la modal d'édition et en réinitialisant l'input sélectionné. 
     * @param {None} - Aucun paramètre requis. 
     */
    cancelEdit() {
        this.showModalEditionInput = false
        this.$store.dispatch('exa_partieFormulaire/setInputSelect', null)
    }

    /** 
     * deleteInput 
     * Supprime l'input spécifié en déclenchant les actions appropriées et en affichant la modal de confirmation de suppression. 
     * @param {InputInterface} input - L'input à supprimer. 
     */
    deleteInput(input: InputInterface) {
        this.$store.dispatch('exa_partieFormulaire/loadPartieFormulaire', this.partieTemp)
        this.$store.dispatch('exa_partieFormulaire/setInputSelect', input)
        this.showModalMessageDeleteInput = true
    }
    
    /** 
     * cancelDeleteInput 
     * Annule la suppression de l'input en réinitialisant l'input sélectionné et en masquant la modal de confirmation de suppression. 
     * @param {None} - Aucun paramètre requis. 
     */
    cancelDeleteInput () {
        this.$store.dispatch('exa_partieFormulaire/setInputSelect', null)
        this.showModalMessageDeleteInput = false
    }
    
    /** 
     * deleteInputSuite 
     * Gère la suppression de l'input en masquant la modal de confirmation de suppression, en supprimant l'input sélectionné et en mettant à jour la structure du formulaire. 
     * @param {None} - Aucun paramètre requis. 
     */
    deleteInputSuite () {
        this.showModalMessageDeleteInput = false
        this.$store.dispatch('exa_partieFormulaire/removeInputSelect')
        if (this.partieTemp) {
            this.partieTemp.inputs = JSON.parse(JSON.stringify(this.$store.state.exa_partieFormulaire.inputs))
        }
        this.emitUpdateStructureFormulaire()
    }

    /** 
     * conditionHandler 
     * Gère la condition de la partie en initialisant les variables de condition et en vérifiant la valeur de condition. 
     * @param {None} - Aucun paramètre requis. 
     */
    conditionHandler () {
        this.condition = null
        this.conditionOk = true
        if (this.partie && this.partie.condition) {
            this.condition = this.$store.getters['exa_formulaire/getInputById'](this.partie.condition.champ_id, this.partie.id)
            this.checkConditionValue()
        }
    }

    /** 
     * checkConditionValue 
     * Vérifie la valeur de la condition et met à jour la variable conditionOk en conséquence. 
     * @param {None} - Aucun paramètre requis. 
     */
    checkConditionValue () {
        this.conditionOk = true
        if (this.condition) {
            this.conditionOk = false
            if (this.condition.value === this.partie.condition.value || (this.partie.condition.value === null && this.condition.value !== '' && !isNull(this.condition.value))) {
                this.conditionOk = true
            } else if (Array.isArray(this.condition.value) && Array.isArray(this.partie.condition.value)) {
                for (let j = 0; j < this.condition.value.length; j++) {
                    for (let k = 0; k < this.partie.condition.value.length; k++) {
                        if (String(this.partie.condition.value[k]) === String(this.condition.value[j])) {
                            this.conditionOk = true
                        }
                    }
                }
            }
        }
    }

    /** 
     * beforeMount 
     * Charge la partie, puis gère les conditions avant le montage du composant. 
     * @param {None} - Aucun paramètre requis. 
     */
    beforeMount () {
        this.loadPartie()
        this.conditionHandler()
    }
}
